export class IndustrySource {
  public getIndustries() {
    return [
      'Airlines',
      'Cashback',
      'Coupons & Deals',
      'Content sites',
      'Closed user group',
      'Financial services',
      'Loyalty offers',
      'Meta sites (price comparison',
      'Travel Agents',
      'Sub-affiliate networks',
      'Other',
    ];
  }
}
